import Vue from 'vue'
import { Message } from 'element-ui'
import command from '../utils/command';
import {packetEncoder,packetDecoder} from './encodec'

let v = new Vue()
v.$message = Message;

var globalCallback = function(param){} //定义外部接收数据的回调函数

//let userId = sessionStorage.getItem("userId")
//var websocketUrl =  `ws://47.92.125.204:10010/ws`;

var webSocket = null;
// var websocketUrl =  `ws://192.168.31.66:11001/ws`;
var websocketUrl =  `wss://ws.tbhtb.com/ws`;

var heartBeatInterval = null; // 心跳定时器
var reconnectInterval = null; // 重连定时器
var reloginInterval = null; //重新登录定时器

let retryCount = 0;
let isReconnecting = false;
const maxRetries = 10;
const baseDelay = 5000; // 前5次重连间隔时间为5秒
const exponentialBaseDelay = 2000; // 后5次重连间隔时间的基数为2秒
// ||v.$message.warning('请先登录')
//var loginData = { token: "your_token_here" }; // 登录数据包
var token = JSON.parse(localStorage.getItem('userToken'));
var loginPacket = {
    clientType: null,  // 示例客户端类型
    imeiNumber: null,  // 示例IMEI号
    token: token // 示例token,
}

//1、获取imei号
function generateUUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}

//2、获取设备类型
function detectDevice() {
    var userAgent = navigator.userAgent;
    if (userAgent.match(/Mobile|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i)) {
        return "mobile";
    } else {
        return "web";//web
    }
}
//3、构造设备类型和imei号
function initClientTypeAndImei(){
    if (!loginPacket.imeiNumber) {
        loginPacket.imeiNumber = generateUUID();
    }
    loginPacket.clientType = detectDevice();
    //console.log("Device ID: ", loginPacket.imeiNumber);
    //console.log("deviceType: ", loginPacket.clientType);
}

//4、初始化websocket
function initWebSocket() {
    if ("WebSocket" in window) {
        webSocket = new WebSocket(websocketUrl);//创建socket对象
        webSocket.binaryType = "arraybuffer";
    } else {
        Message({
            message: '该浏览器不支持websocket!',
            type: 'warning'
        });
        return;
    }
    //打开
    webSocket.onopen = function() {
        webSocketOpen();
        // 连接成功后重置重连计数和标志位
        retryCount = 0;
        isReconnecting = false;
    };
    //收信
    webSocket.onmessage = function(e) {
        webSocketOnMessage(e);
    };
    //关闭
    webSocket.onclose = function(e) {
        webSocketOnClose(e);
        if (!isReconnecting) {
            attemptReconnect();
        }
    };
    //连接发生错误的回调方法
    webSocket.onerror = function(e) {
        webSocketOnError(e);
        if (!isReconnecting) {
            attemptReconnect();
        }
    };
}

//5、连接socket建立时触发
function webSocketOpen() {
    console.log("WebSocket连接成功");
    initClientTypeAndImei();
    // 首次握手，发送登录数据包
    webSocket.send(packetEncoder(loginPacket,command.login_request));
}

//6、发送数据
function sendMessage(data,agentCommand) {
    //在这里根据自己的需要转换数据格式
    webSocket.send(packetEncoder(data,agentCommand));
}

//7、接收消息
function webSocketOnMessage(e) {
    let message = packetDecoder(e.data)
   // console.log("收到服务端消息: ", message);
    //var message = JSON.parse(e.data);
    if (message.code === 200 && message.command === command.login_ack) {
        // 登录成功，启动心跳机制并停止重连
        console.log("登录成功");
        stopReconnect(); 
        stopLoginRequest();
        startHeartBeat();
    } else if (message.code === 400 && message.command === command.login_ack) {
        // 登录失败，重新发送登录数据包
        startLoginRequest();
    } else if (message.code === 200 && message.command === command.mutual_exclusion_login){ 
        //下线通知 用于多端互斥
        //console.log("被踢下线");
    } else if (message.code === 200 && message.command === command.p2p_message_request){ 
        //console.log("收到消息请求包，要回复ack");
        //单聊消息receive_ack包
        var p2pMessageReceiveAckPakcet={
            fromId:message.data.toId,
            toId:message.data.fromId,
            messageKey:message.data.messageKey,
            messageSequence:message.data.messageSequence
        }
        webSocket.send(packetEncoder(p2pMessageReceiveAckPakcet,command.p2p_message_receive_ack)); 
        //消息已读回执包
        var p2pMessageHasReadPakcet={
            fromId:message.data.toId,
            toId:message.data.fromId,
            messageSequence:message.data.messageSequence,
            conversationType:0 //0代表单聊会话 1代表群聊会话
        }
        webSocket.send(packetEncoder(p2pMessageHasReadPakcet,command.p2p_message_has_read)); 
         
    }else if (message.code === 200 && String(message.command).charAt(0)==='2'){ //2开头代表群聊
        //console.log('message.command==='+message.command)
        globalCallback(message.data,Number(message.command));
    }
    else if (message.code === 200 && String(message.command).charAt(0)==='5'){ //5开头代表图片传输
        //console.log('message.command==='+message.command)
        globalCallback(message.data,Number(message.command));
    }
    else{
        // 处理其他收到的消息
        //console.log("处理其他收到的消息：")
        //console.log("body=="+JSON.stringify(message))
        globalCallback(message.data,Number(message.command));//将data传给在外定义的接收数据的函数，至关重要。
    }
}


//1、在其他需要socket地方调用的函数，用来发送数据及接受数据
function sendSocket(agentData,agentCommand,agentCallback) {
    //console.log('agentData==')
    //console.log(agentData==null,agentCommand==null)
    if(agentData==null||agentCommand==null){
        globalCallback = agentCallback;
        return;
    }
    globalCallback = agentCallback;
    //下面的判断主要是考虑到socket连接可能中断或者其他的因素，可以重新发送此条消息。
    switch (webSocket.readyState) {
        //CONNECTING：值为0，表示正在连接。
        case webSocket.CONNECTING:
            setTimeout(function() {
                sendSocket(agentData,agentCommand,agentCallback);
            }, 1000);
        break;
        //OPEN：值为1，表示连接成功，可以通信了。
        case webSocket.OPEN:
            sendMessage(agentData,agentCommand);
        break;
        //CLOSING：值为2，表示连接正在关闭。
        case webSocket.CLOSING:
            setTimeout(function() {
                sendSocket(agentData,agentCommand,agentCallback);
            }, 1000);
        break;
        //CLOSED：值为3，表示连接已经关闭，或者打开连接失败。
        case webSocket.CLOSED:
        // do something
        break;
        default:
        // this never happens
        break;
    }
}

//关闭时触发
function webSocketOnClose(e) {
    //console.log("WebSocket连接关闭: ", e);
    stopHeartBeat();
    //startReconnect();
    
}

//发生错误时触发
function webSocketOnError(e) {
    //console.log("WebSocket发生错误: ", e);
    stopHeartBeat();
    //startReconnect();
}

//启动心跳机制
function startHeartBeat() {
    heartBeatInterval = setInterval(() => {
        if (webSocket.readyState === WebSocket.OPEN) {
            webSocket.send(packetEncoder({heartBeat:'hello'},command.heart_beat));
            //console.log("发送心跳包");
        }
    }, 18000); // 每隔18秒发送一次心跳包
}

//停止心跳机制
function stopHeartBeat() {
    if (heartBeatInterval) {
        clearInterval(heartBeatInterval);
        heartBeatInterval = null;
    }
}

//启动重连机制
function startReconnect() {
    if (!reconnectInterval) {
        reconnectInterval = setInterval(() => {
            console.log("尝试重新连接...");
            initWebSocket();
        }, 6000); // 每隔1秒尝试重连一次
    }
}


//停止重连机制
function stopReconnect() {
    if (reconnectInterval) {
        clearInterval(reconnectInterval);
        reconnectInterval = null;
    }
}

//重新登录机制
function startLoginRequest() {
    initClientTypeAndImei();
    if (!reloginInterval) {
        reloginInterval = setInterval(() => {
            console.log("尝试重新登录...");
            webSocket.send(packetEncoder(loginPacket,command.login_request));
        }, 3000); // 每隔1秒尝试重连一次
    }
}

//停止重新登录机制
function stopLoginRequest() {
    if (reloginInterval) {
        clearInterval(reloginInterval);
        reloginInterval = null;
    }
}

//尝试重新连接
function attemptReconnect() {
    if (retryCount < maxRetries) {
        isReconnecting = true; // 设置重连标志位
        let delay;
        if (retryCount < 5) {
            delay = baseDelay;
        } else {
            delay = exponentialBaseDelay * Math.pow(2, retryCount - 5);
        }

        setTimeout(function() {
            console.log(`Attempting to reconnect, try number ${retryCount + 1}`);
            retryCount++;
            initWebSocket();
            isReconnecting = false; // 重置重连标志位，确保可以继续重连
        }, delay);
    } else {
        console.log("Max retry attempts reached. Giving up on reconnecting.");
        isReconnecting = false; // 重置重连标志位
    }
}
 function getWebSocket(){
    if(webSocket){
        return webSocket;
    }else{
        return null;
    }
 }
 
export default {
  initWebSocket,
  sendSocket,
  packetEncoder, 
  packetDecoder,
  getWebSocket
};
